// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lVLY","newExpiryDate":"styles_newExpiryDate__26hjP","footer":"styles_footer__3Fo_p"};